const imagesList = document.querySelectorAll('.js-images-list');

const showHiddenImagesCount = () => {
    imagesList.forEach((list) => {
        const imagesListItems = list.querySelectorAll('.js-images-list-item');
        const mediaQuery = window.innerWidth;
        let count;

        if (mediaQuery >= 480) {
            count = +list.dataset.count;
        } else {
            count = +list.dataset.countMobile;
        }

        if (imagesListItems.length > count) {
            for (let i = count; i < imagesListItems.length; i++) {
                imagesListItems[i].classList.add('hidden');
            }

            const lastVisibleImage = imagesListItems[count - 1];

            const div = document.createElement('div');
            const span = document.createElement('span');
            div.classList.add('images-list__count', 'text');
            span.textContent = '+' + (imagesListItems.length - count);
            div.append(span);
            lastVisibleImage.append(div);
        }
    });
};

if (imagesList.length) {
    showHiddenImagesCount();
}
